import { render } from "./levels-description.vue?vue&type=template&id=79842f7a&scoped=true&ts=true"
import script from "./levels-description.vue?vue&type=script&lang=ts"
export * from "./levels-description.vue?vue&type=script&lang=ts"

import "./levels-description.vue?vue&type=style&index=0&id=79842f7a&lang=scss&scoped=true"
import "./levels-description.vue?vue&type=style&index=1&id=79842f7a&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79842f7a"]])

export default __exports__